module.exports = __webpack_public_path__ + "assets/img/pegi-3.5720e344.png";